'use client'

import { useRef } from 'react'

import { useTopNav } from '@src/components/TopNavV3/TopNavContext'
import { TopNavMobileBar } from '@src/components/TopNavV3/TopNavMobile/TopNavMobileBar'
import { TopNavMobileSlidingPanel } from '@src/components/TopNavV3/TopNavMobile/TopNavMobileSlidingPanel'
import { useLockScroll } from '@src/hooks/useLockScroll'
import { useBreakpoints } from '@src/utils/breakpoints.util'

export const TopNavMobile = () => {
  const navBarRef = useRef<HTMLDivElement | null>(null)
  const { isExpanded } = useTopNav()
  const { isDesktop } = useBreakpoints()

  useLockScroll({ isExpanded: isExpanded && !isDesktop })

  const navBox = navBarRef?.current?.getBoundingClientRect()

  return (
    <nav className="relative overflow-x-clip lg:hidden">
      <div
        ref={navBarRef}
        className="z-50 h-12 w-full bg-bodi-black-text font-medium text-bodi-white"
      >
        <TopNavMobileBar />
      </div>
      <TopNavMobileSlidingPanel navBox={navBox} />
    </nav>
  )
}
